import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsWorkerBadgesEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.WORKER_BADGES, {
    defaultValue: false,
  });
}
